import { render, staticRenderFns } from "./LsgActionsNew.vue?vue&type=template&id=662e7af3&"
import script from "./LsgActionsNew.vue?vue&type=script&lang=js&"
export * from "./LsgActionsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports